import './app.scss';
import { persistor, store } from '@zonofi/seller-rtk-store';
import { Provider as ReduxProvider } from 'react-redux';
import './fonts.css';
import { AppNavigator } from './app-navigator/app-navigator';
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { firebaseConfig } from '../firebase.config';
import { PersistGate } from 'redux-persist/integration/react';

// Firebase setup for web
globalThis.sellerFirebaseApp = initializeApp(firebaseConfig);
globalThis.sellerFirebasedb = getFirestore(globalThis.sellerFirebaseApp);

export default function App() {
  return (
    <ReduxProvider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <AppNavigator />
      </PersistGate>
    </ReduxProvider>
  );
}
